import React, { useEffect, useState } from "react";
import Loader from "../global/Loader";
import DataTable from "../datatable/DataTable";
import { withdrawals } from "../../constants/data";
import CurrencyFormatter from "../global/CurrencyFormatter";
import DateTimeFormat from "../global/DateTimeFormat";
import { withdrawal_commissions_unregistered } from "../../constants/Tariffs";
import HeaderInfo from "../agents/HeaderInfo";
import Button from "../global/Button";

function WithdrawalsReport() {
  const headers = [
    "Transaction ID",
    "Client ID",
    "Amount",
    "Commission",
    "Date",
    "Print statement",
  ];
  let tableRows = [];

  let commission = 0;

  if (withdrawals.length) {
    for (let i = 0; i < withdrawals.length; i++) {
      const commissionEarned =
        withdrawals[i].type > 1
          ? withdrawal_commissions_unregistered(withdrawals[i].amount_withdrawn)
          : withdrawal_commissions_unregistered(
              withdrawals[i].amount_withdrawn
            );
      commission = commission += commissionEarned;
      tableRows.push({
        withdrawal_id: withdrawals[i].withdrawal_id,
        client_id: withdrawals[i].client_id_number,
        amount_withdrawn: (
          <CurrencyFormatter value={withdrawals[i].amount_withdrawn} />
        ),
        commision: <CurrencyFormatter value={commissionEarned} />,
        created_at: (
          <DateTimeFormat>{withdrawals[i].created_at}</DateTimeFormat>
        ),
        more: (
          <i
            className="bx bx-printer links text-[16px] cursor-pointer"
            onClick={() => printStatement(withdrawals[i])}
          ></i>
        ),
      });
    }
  }

  const printStatement = (id) => {
    console.log(id);
  };

  // fetching data
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());

  useEffect(() => {
    handleAction(selectedMonth);
  }, [selectedMonth]);

  let handleAction = (val) => {
    console.log(val);
  };

  const displayContent = withdrawals ? (
    !withdrawals.length ? (
      <Loader />
    ) : (
      <DataTable headers={headers} data={tableRows} />
    )
  ) : (
    <Loader />
  );

  return (
    <div>
      {/* header information */}
      <HeaderInfo commission={commission} action={setSelectedMonth} />

      <div className="flex items-center justify-end mb-3">
        <Button text={"Export Excel"} />
        <Button text={"Export PDF"} bgColor={"bg-red-500"} />
      </div>
      {displayContent}
    </div>
  );
}

export default WithdrawalsReport;
